import React, { ReactNode } from 'react'
import { SerializedStyles } from '@emotion/react'

import {
    Typography,
    DialogTitle,
    DialogContent,
    DialogActions,
} from '@mui/material'

import useStyle from 'shared/hooks/useStyle'

import styles from './Dialog.style'

type Props = {
    titleMessage: string
    buttons?: ReactNode
    children: ReactNode,
    customClasses?: {
        dialogContentRoot?: SerializedStyles,
    },
}

const Dialog = ({
    children,
    titleMessage,
    buttons,
    customClasses,
}: Readonly<Props>) => {
    const classes = useStyle(styles)

    return (
        <>
            <DialogTitle
                css={classes.dialogTitle}
            >
                <Typography
                    variant="h3"
                    css={classes.titleHeader}
                    component="div"
                >
                    {titleMessage}
                </Typography>
            </DialogTitle>
            <DialogContent css={[
                classes.dialogContentRoot,
                customClasses?.dialogContentRoot,
            ]}
            >
                {children}
            </DialogContent>
            <DialogActions
                css={classes.dialogActionsRoot}
            >
                {buttons}
            </DialogActions>
        </>
    )
}

export default Dialog
